// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdvocateCardListComponentController from "../../view_components/community_site/advocate_card_list_component_controller"
application.register("advocate-card-list-component", AdvocateCardListComponentController)

import AdvocateMapComponentController from "../../view_components/stoked/advocate_map_component_controller"
application.register("advocate-map-component", AdvocateMapComponentController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import ColorInputController from "./color_input_controller"
application.register("color-input", ColorInputController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocationPickerController from "../../view_components/ui/form/location_picker_controller"
application.register("location-picker", LocationPickerController)

import TemplateLockToggleController from "./template_lock_toggle_controller"
application.register("template-lock-toggle", TemplateLockToggleController)
